import type { ReactNode } from 'react'
import type { TelephonyLeaseView } from '@/shared/api/__generated__'
import { formatDateTime } from '@/shared/lib'
import { Card } from '@/shared/ui/card'
import { Icon } from '@/shared/ui/icon'
import { StatusBadge } from '@/shared/ui/status-badge'
import { leaseStatus } from '../model/statuses'
import { AccountLink, PoolLink } from './links'

interface LeaseRowProps {
  lease: TelephonyLeaseView
  // Юнит — сущность соседнего слайса: ссылку на него подаёт композиция сверху.
  unitRef?: ReactNode
  actions?: ReactNode
  error?: ReactNode
}

export function LeaseRow({ lease, unitRef, actions, error }: LeaseRowProps) {
  return (
    <Card className="flex flex-wrap items-center gap-x-6 gap-y-3 p-4">
      <div className="flex min-w-0 flex-1 basis-52 items-center gap-3">
        <span className="flex size-10 shrink-0 items-center justify-center rounded-control bg-raise text-muted">
          <Icon name="link" size={18} />
        </span>
        <div className="min-w-0">
          <p className="truncate text-body-sm font-medium">{lease.id}</p>
          <p className="truncate text-caption text-faint">{formatDateTime(lease.created_at)}</p>
        </div>
      </div>
      <dl className="flex flex-wrap items-center gap-x-6 gap-y-1 text-body-sm">
        <div className="min-w-0">
          <dt className="text-caption text-faint">учётка</dt>
          <dd>
            <AccountLink id={lease.sip_account_id} />
          </dd>
        </div>
        <div className="min-w-0">
          <dt className="text-caption text-faint">пул</dt>
          <dd>
            <PoolLink id={lease.pool_id} />
          </dd>
        </div>
        <div className="min-w-0">
          <dt className="text-caption text-faint">юнит</dt>
          <dd>{unitRef ?? lease.unit_id}</dd>
        </div>
        <div>
          <dt className="text-caption text-faint">линии</dt>
          <dd>{lease.lines_count}</dd>
        </div>
      </dl>
      <div className="flex items-center gap-2">
        <StatusBadge {...leaseStatus(lease.status)} />
        {actions}
      </div>
      {error}
    </Card>
  )
}
